<template>
  <div>
    <Dialog
        :dismissableMask="true"
        :style="{ width: '35vw' }"
        :modal="true"
        :visible.sync="show"
        @hide="closeDialog"
        :contentStyle="{overflow: 'visible'}"
    >
      <template #header>
        <i style=" transform: scale(1.7); " class="pi pi-th-large"></i>
        <h1>הוספת הודעת מערכת</h1>
      </template>

      <div class="p-pt-4 p-fluid p-grid">

        <div class="p-field p-col-12 p-md-12">
          <label for="lastname6">תוכן</label>
          <textarea  style="    width: 100%;"
                     autoResize="true"
                     class="p-inputtextarea p-inputtext p-component"
                     id="lastname6" type="text" v-model="newItem.content" />
        </div>
      </div>
        <div class=" p-fluid p-grid">

        <div class="p-field p-col-12 p-md-6">
              <label for="startDate">תאריך התחלה</label>
              <calendar :showTime="true" type="text" v-model="newItem.startDate" />
          </div>
          <div class="p-field p-col-12 p-md-6">
              <label for="endDate">תאריך סוף</label>
              <calendar :showTime="true" type="text" v-model="newItem.endDate" />
          </div>
        </div>

        <!-- type -->
            <div class=" p-fluid p-grid">

        <div class="p-field p-col-12 p-md-6">
          <label>סוג</label>

          <Dropdown v-model="newItem.type" :options="types">
            <template #option="slotProps">
              <span class="subject-tracking" :class="`t-${slotProps.option}`">{{ getTypeLabel(slotProps.option) }}</span>
            </template>
            <template #value="slotProps">
              <div v-if="slotProps.value">
                <span class="subject-tracking" :class="`t-${newItem.type}`">{{ getTypeLabel(newItem.type) }}</span>
              </div>
              <span v-else> בחר סוג </span>
            </template>
          </Dropdown>
        </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>סדר</label>
                        <input-number type="text" v-model="newItem.sort" />
                    </div>


      </div>


      <template #footer>
        <Button
            label="ביטול"
            icon="pi pi-times"
            @click="closeDialog"
            class="p-button-secondary"
        />
        <Button class="p-button-success" label="הוספה" icon="pi pi-check" @click="post"/>
      </template>
    </Dialog>
  </div>
</template>

<script>
import Service from "../../../../service/Service";

export default {
  service: null,
  props: {
    show: Boolean,
  },
  created() {
    this.service = new Service();
  },
  mounted() {
    this.setNewItwmFields();
  },
  data() {
    return {
        ENTITY: 'system-messages',
      types: ["error","warn","success", "info"],
      newItem: null,
    };
  },

  methods: {
    getTypeLabel(type) {
      switch (type) {
        case "error":
          return "סכנה";
        case "warn":
          return "אזהרה";
        case "success":
          return "הצלחה";
        case "info":
          return "מידע";
        default:
          return "שגיאה";
      }
    },
    setNewItwmFields() {
        const nextWeek = new Date()
        nextWeek.setDate(nextWeek.getDate()+ 7)
      this.newItem = {
        content: null,
        type: 'info',
        endDate: nextWeek,
        startDate: new Date(),
          sort: 0
      };
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async post() {
      let validate = true;
      for (const key in this.newItem) {
        if (this.newItem[key] === null) {
          validate = false;
        }
      }

      if (validate === true) {
          this.newItem.endDate = this.newItem.endDate.getTime()
          this.newItem.startDate = this.newItem.startDate.getTime()
        await this.service
          .post(this.newItem, this.ENTITY)
          .then((data) => {
            this.$emit("addItem", this.newItem);
            this.setNewItwmFields();
            this.openNotification(
              "success",
              `מעולה`,
              `הכיתה התתוספה במערכת`
            );

            this.closeDialog();
          })
          .catch(() => {
            this.openNotification(
              "danger",
              `אופס`,
              `אולי קיים כבר משתמש עם ת.ז. זהה`
            );
          });
      } else {
        this.openNotification(
          "danger",
          `אופס`,
          `חלק מהשדות חסרים או שגויים`
        );
      }
    },
    openNotification(color, title, text, position = "right-left", duration = 3000) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  },
};
</script>

<style >
</style>